<template>
<div>
  <h3
    class="title"
    @click="expanded=!expanded"
  >
    <slot name="title"></slot>
    <v-icon
      class="eicon"
      v-if="!expanded"
    >fas fa-angle-down</v-icon>
    <v-icon
      class="eicon"
      v-if="expanded"
    >fas fa-angle-up</v-icon>
  </h3>
  <template v-if="expanded">
    <div class="content"><slot></slot></div>
  </template>
  <template v-if="!expanded">
    <div class="content-not-expanded">{{ collapsedText }}</div>
  </template>
</div>
</template>

<script>
  export default {
    name: 'CollapsibleSection',
    props: ['collapsedText'],
    data: function () {
      return {
        expanded: false,
      }
    },
  }
</script>

<style scoped>
  .title {
    cursor: pointer;
  }
  .content {
    padding-top: 20px;
  }

  .content-not-expanded {
    font-size: 1em;
    font-style: italic;
  }

  .eicon {
    margin-left: 10px;
  }
</style>
